import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms'
@Directive({
  selector: '[appMail]'
})
export class MailDirective {

  constructor(public control:NgControl) { }

  @HostListener('input', ['$event']) changeForm() {
    const cadena = this.control.control.value.replace(/[^A-Za-z0-9.@_-]/g, '');
    this.control.control.setValue(cadena)
  }
}
